import { render, staticRenderFns } from "./SelectAges.vue?vue&type=template&id=0b0c5e76"
import script from "./SelectAges.vue?vue&type=script&lang=js"
export * from "./SelectAges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports